// WeekPlanLayout.jsx
import React, { useState, useEffect } from "react";
import { Button, Space } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import MonthCalendar from "./ThreeMonthCalendar";
import WeekPlanContent from "./WeekPlanContent";
import SettingsModal from "./SettingsModal";
import { ConfigProvider } from "antd";
import deDE from "antd/locale/de_DE";
import { getWeekPlanSettings } from "../../utils/cookieManager";
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import styles from "./WeekPlanLayout.module.css";

// Enable ISO week plugin for dayjs
dayjs.extend(isoWeek);
const WeekPlanLayout = () => {
  const { t } = useTranslation();
  const currentDate = dayjs();
  const [selectedYear, setSelectedYear] = useState(currentDate.year());
  const [selectedWeek, setSelectedWeek] = useState(currentDate.isoWeek());
  const [isMobile, setIsMobile] = useState(false);
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [weekPlanSettings, setWeekPlanSettings] = useState(getWeekPlanSettings());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleWeekChange = ({ year, week }) => {
    console.log('WeekPlanLayout: Week change requested', { year, week, currentYear: selectedYear, currentWeek: selectedWeek });
    
    // Only update if the week or year actually changed
    if (selectedYear !== year || selectedWeek !== week) {
      console.log('WeekPlanLayout: Updating week selection', { from: { year: selectedYear, week: selectedWeek }, to: { year, week } });
      setSelectedYear(year);
      setSelectedWeek(week);
    } else {
      console.log('WeekPlanLayout: Week selection unchanged, skipping update');
    }
  };

  const handleSettingsChange = (newSettings) => {
    setWeekPlanSettings(newSettings);
  };

  const openSettings = () => {
    setSettingsVisible(true);
  };

  const closeSettings = () => {
    setSettingsVisible(false);
  };

  return (
    <ConfigProvider locale={deDE}>
      <div className={styles.layoutContainer}>
        <div className={styles.headerSection}>
          <div className={styles.calendarWrapper}>
            <MonthCalendar 
              onWeekSelect={handleWeekChange} 
              isMobile={isMobile} 
              selectedWeek={selectedWeek}
              selectedYear={selectedYear}
            />
          </div>
          <div className={styles.settingsButtonWrapper}>
            <Button 
              type="default" 
              icon={<SettingOutlined />} 
              onClick={openSettings}
              title={t('weekPlanSettings')}
            >
              {!isMobile && t('settings')}
            </Button>
          </div>
        </div>
        <WeekPlanContent 
          selectedYear={selectedYear} 
          selectedWeek={selectedWeek} 
          weekPlanSettings={weekPlanSettings}
          onWeekChange={handleWeekChange}
        />
        <SettingsModal
          visible={settingsVisible}
          onClose={closeSettings}
          onSettingsChange={handleSettingsChange}
        />
      </div>
    </ConfigProvider>
  );
};

// Removed custom getWeekNumber function - now using dayjs ISO weeks consistently

export default WeekPlanLayout;
